// @generated by protoc-gen-connect-es v1.3.0
// @generated from file proctoring/v1/recording.proto (package proctoring.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { RecordingServiceAckRequest, RecordingServiceAckResponse, RecordingServiceAttachMediaInfoRequest, RecordingServiceAttachMediaInfoResponse, RecordingServiceConcatRequest, RecordingServiceConcatResponse, RecordingServiceEndRequest, RecordingServiceEndResponse, RecordingServiceGetAllRequest, RecordingServiceGetAllResponse, RecordingServiceGetBlobUploadUrlRequest, RecordingServiceGetBlobUploadUrlResponse, RecordingServiceGetRequest, RecordingServiceGetResponse, RecordingServiceListRequest, RecordingServiceListResponse, RecordingServiceStartRequest, RecordingServiceStartResponse, RecordingServiceUncheckedGetBlobUploadUrlRequest, RecordingServiceUncheckedGetBlobUploadUrlResponse } from "./recording_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service proctoring.v1.RecordingService
 */
export const RecordingService = {
  typeName: "proctoring.v1.RecordingService",
  methods: {
    /**
     * @generated from rpc proctoring.v1.RecordingService.Start
     */
    start: {
      name: "Start",
      I: RecordingServiceStartRequest,
      O: RecordingServiceStartResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.GetBlobUploadUrl
     */
    getBlobUploadUrl: {
      name: "GetBlobUploadUrl",
      I: RecordingServiceGetBlobUploadUrlRequest,
      O: RecordingServiceGetBlobUploadUrlResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.UncheckedGetBlobUploadUrl
     */
    uncheckedGetBlobUploadUrl: {
      name: "UncheckedGetBlobUploadUrl",
      I: RecordingServiceUncheckedGetBlobUploadUrlRequest,
      O: RecordingServiceUncheckedGetBlobUploadUrlResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.Ack
     */
    ack: {
      name: "Ack",
      I: RecordingServiceAckRequest,
      O: RecordingServiceAckResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.Concat
     */
    concat: {
      name: "Concat",
      I: RecordingServiceConcatRequest,
      O: RecordingServiceConcatResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.End
     */
    end: {
      name: "End",
      I: RecordingServiceEndRequest,
      O: RecordingServiceEndResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.AttachMediaInfo
     */
    attachMediaInfo: {
      name: "AttachMediaInfo",
      I: RecordingServiceAttachMediaInfoRequest,
      O: RecordingServiceAttachMediaInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.List
     */
    list: {
      name: "List",
      I: RecordingServiceListRequest,
      O: RecordingServiceListResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.Get
     */
    get: {
      name: "Get",
      I: RecordingServiceGetRequest,
      O: RecordingServiceGetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.RecordingService.GetAll
     */
    getAll: {
      name: "GetAll",
      I: RecordingServiceGetAllRequest,
      O: RecordingServiceGetAllResponse,
      kind: MethodKind.ServerStreaming,
    },
  }
};

